/* Belle Époque – Custom PDP JavaScript (Impulse 9) */
(() => {
  'use strict';

  // ── STATE ──────────────────────────────────────────────────────────────────
  const state = { variantId: null, price: 0, qty: 1, available: true };

  // ── GALLERY ────────────────────────────────────────────────────────────────
  window.beSwitchImg = function (thumb, src, num, total) {
    const main = document.getElementById('be-main-img');
    if (main) main.src = src;
    document.querySelectorAll('.be-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const counter = document.getElementById('be-img-counter');
    if (counter) counter.textContent = num + ' / ' + total;
  };

  window.beGalleryNav = function (delta) {
    const thumbs = Array.from(document.querySelectorAll('.be-thumb'));
    if (!thumbs.length) return;
    const active = thumbs.findIndex(t => t.classList.contains('active'));
    const next = (active + delta + thumbs.length) % thumbs.length;
    thumbs[next].click();
  };

  // ── VARIANTS ───────────────────────────────────────────────────────────────
  window.beSelectVariant = function (el, priceCents, priceFormatted, variantId, available) {
    document.querySelectorAll('.be-variant-card').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');
    state.variantId = variantId;
    state.price = priceCents;
    state.available = available !== false && available !== 'false';

    const priceEl = document.getElementById('be-display-price');
    if (priceEl) priceEl.textContent = priceFormatted;
    const mobilePriceEl = document.getElementById('be-display-price-mobile');
    if (mobilePriceEl) mobilePriceEl.textContent = priceFormatted;

    const tooltip = document.getElementById('be-variant-tooltip');
    if (tooltip) tooltip.textContent = el.dataset.hint || '';

    // Kale wortel heeft een eigen levermoment: urgency-bar en lever-USP's
    // wisselen naar de novemberteksten
    const isBareroot = el.dataset.bareroot === 'true';
    const urgencyBar = document.getElementById('be-urgency-bar');
    if (urgencyBar) urgencyBar.classList.toggle('be-urgency-bar--bareroot', isBareroot);
    const trustRow = document.getElementById('be-trust-row');
    if (trustRow) trustRow.classList.toggle('be-trust-row--bareroot', isBareroot);

    // Update Impulse product-form variant ID input
    const idInput = document.querySelector('product-form input[name="id"]');
    if (idInput) idInput.value = variantId;

    // Update ATC button state
    const cartBtn = document.getElementById('be-btn-cart');
    if (cartBtn) {
      cartBtn.disabled = !state.available;
      cartBtn.classList.toggle('be-btn-cart--oos', !state.available);
      const textSpan = cartBtn.querySelector('[data-add-to-cart-text]');
      if (textSpan) {
        if (state.available) {
          textSpan.innerHTML = `<svg class="be-icon be-icon--md" style="stroke:#fff"><use href="#be-icon-cart"/></svg> Voeg toe aan winkelwagen <span class="be-btn-cart-price" id="be-cart-price">${priceFormatted}</span>`;
        } else {
          textSpan.innerHTML = `<svg class="be-icon be-icon--md" style="stroke:#fff"><use href="#be-icon-x"/></svg> Tijdelijk uitverkocht`;
        }
      }
    }

    beUpdateCartPrice();
  };

  // ── QUANTITY ───────────────────────────────────────────────────────────────
  window.beChangeQty = function (delta) {
    state.qty = Math.max(1, state.qty + delta);
    const qtyEl = document.getElementById('be-qty');
    if (qtyEl) qtyEl.textContent = state.qty;
    const qtyInput = document.getElementById('be-qty-input');
    if (qtyInput) qtyInput.value = state.qty;
    beUpdateCartPrice();
  };

  function beUpdateCartPrice() {
    const priceEl = document.getElementById('be-cart-price');
    if (!priceEl || !state.price) return;
    const total = (state.price * state.qty) / 100;
    priceEl.textContent = '€ ' + total.toFixed(2).replace('.', ',');
  }

  // ── ACCORDION ─────────────────────────────────────────────────────────────
  window.beToggleAcc = function (btn) {
    const body = btn.nextElementSibling;
    const isOpen = body.classList.contains('open');
    document.querySelectorAll('.be-acc-body').forEach(b => b.classList.remove('open'));
    document.querySelectorAll('.be-acc-trigger').forEach(b => b.classList.remove('open'));
    if (!isOpen) {
      body.classList.add('open');
      btn.classList.add('open');
    }
  };

  // ── BUNDLE TOGGLE ──────────────────────────────────────────────────────────
  window.beToggleBundle = function (card) {
    card.classList.toggle('selected');
    beBundleUpdateTotal();
  };

  function beBundleUpdateTotal() {
    const items = document.querySelectorAll('.be-bundle-item[data-price]');
    let total = 0;
    items.forEach(item => {
      if (item.classList.contains('selected')) {
        total += parseInt(item.dataset.price, 10);
      }
    });
    const formatted = total > 0 ? '€ ' + (total / 100).toFixed(2).replace('.', ',') : '—';
    const el = document.getElementById('be-bundle-total');
    if (el) el.textContent = formatted;
    const totalDisplay = document.querySelector('.be-bundle-price-total');
    if (totalDisplay) totalDisplay.textContent = formatted;
  }

  // ── BUNDLE ADD TO CART ─────────────────────────────────────────────────────
  async function beAddToCartApi(variantId, quantity) {
    const url = (window.theme && theme.routes && theme.routes.cartAdd)
      ? theme.routes.cartAdd
      : '/cart/add.js';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Cart error');
    }
    return res.json();
  }

  window.beAddBundle = async function (btn) {
    const selected = [...document.querySelectorAll('.be-bundle-item.selected[data-variant]')];
    if (!selected.length) return;

    const origHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg> Even geduld…`;

    try {
      for (const card of selected) {
        await beAddToCartApi(card.dataset.variant, 1);
      }
      btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Toegevoegd!`;
      btn.style.background = 'var(--be-green)';
      btn.style.boxShadow = '0 4px 14px rgba(43,86,84,.3)';
      // Open Impulse cart drawer
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (err) {
      console.error('[BE bundle]', err);
      btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg> ${err.message || 'Probeer opnieuw'}`;
      btn.style.background = '#b91c1c';
    }
    setTimeout(() => {
      btn.innerHTML = origHTML;
      btn.style.background = '';
      btn.style.boxShadow = '';
      btn.disabled = false;
    }, 2400);
  };

  // ── INIT ───────────────────────────────────────────────────────────────────
  function beInit() {
    const firstCard = document.querySelector('.be-variant-card.selected');
    if (firstCard) {
      state.variantId = parseInt(firstCard.dataset.variantId, 10);
      state.price = parseInt(firstCard.dataset.price, 10);
      state.available = firstCard.dataset.available !== 'false';
    }
    beUpdateCartPrice();
    beBundleUpdateTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beInit);
  } else {
    beInit();
  }

  document.addEventListener('page:load', beInit);
  document.addEventListener('shopify:section:load', beInit);

  // ── NATIVE BUTTON PRICE SYNC ──────────────────────────────────────────────
  document.addEventListener('variant:change', function(event) {
    var priceEl = document.querySelector('[data-be-atc-price]');
    if (!priceEl || !event.detail || !event.detail.variant) return;
    var variant = event.detail.variant;
    if (variant.available) {
      priceEl.style.display = '';
      priceEl.textContent = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(variant.price, window.theme.moneyFormat)
        : '€ ' + (variant.price / 100).toFixed(2).replace('.', ',');
    } else {
      priceEl.style.display = 'none';
    }
  });

  // ── VARIANT INFO TOOLTIP (mobile) ────────────────────────────────────────
  (function() {
    var btn     = document.getElementById('be-variant-info-btn');
    var tooltip = document.getElementById('be-variant-tooltip');
    if (!btn || !tooltip) return;

    // Pre-fill tooltip with selected variant's hint
    var selected = document.querySelector('.be-variant-card.selected');
    if (selected && selected.dataset.hint) tooltip.textContent = selected.dataset.hint;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = tooltip.classList.toggle('open');
      btn.classList.toggle('active', open);
    });
    document.addEventListener('click', function() {
      tooltip.classList.remove('open');
      btn.classList.remove('active');
    });
  })();

  // ── FORM BRIDGE (Impulse cart drawer) ─────────────────────────────────────
  document.addEventListener('product-form:cart:navigate', function(event) {
    if (window.theme && theme.settings && theme.settings.cartType !== 'page') {
      event.preventDefault();
    }
  });
  document.addEventListener('product-form:submit:success', function() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });
  document.addEventListener('product-form:submit:error', function(event) {
    var btn = document.getElementById('be-btn-cart');
    if (!btn) return;
    var originalHTML = btn.innerHTML;
    var msg = (event.detail && event.detail.error && event.detail.error.description)
      ? event.detail.error.description
      : (btn.dataset.labelError || 'Niet beschikbaar');
    btn.innerHTML = '<svg class="be-icon be-icon--md" style="stroke:#fff"><use href="#be-icon-x"/></svg> ' + msg;
    btn.style.background = '#b91c1c';
    setTimeout(function() {
      btn.innerHTML = originalHTML;
      btn.style.background = '';
    }, 3000);
  });
})();

// ── KALE WORTEL — levermelding in de cart drawer ─────────────────────────────
// De drawer-items worden door Impulse client-side gerenderd; een observer op de
// productlijst toont/verbergt de melding zodra er een kale-wortel-variant in de
// winkelwagen zit. Trefwoorden dekken ook de (toekomstige) de/en/fr-vertalingen.
(function () {
  var TERMS = ['kale wortel', 'wurzel', 'bare root', 'bare-root', 'racine'];
  var ROOTS = ['CartDrawer', 'CartPageForm'];

  function beUpdateBarerootNotices() {
    ROOTS.forEach(function (id) {
      var root = document.getElementById(id);
      if (!root) return;
      var notice = root.querySelector('[data-be-bareroot-notice]');
      var items = root.querySelector('[data-products]');
      if (!notice || !items) return;
      var text = (items.textContent || '').toLowerCase();
      var hit = TERMS.some(function (t) { return text.indexOf(t) !== -1; });
      notice.hidden = !hit;
    });
  }

  function beInitBarerootNotice() {
    ROOTS.forEach(function (id) {
      var root = document.getElementById(id);
      var items = root && root.querySelector('[data-products]');
      if (!items || items.dataset.beBarerootBound) return;
      items.dataset.beBarerootBound = '1';
      new MutationObserver(beUpdateBarerootNotices).observe(items, { childList: true, subtree: true });
    });
    beUpdateBarerootNotices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beInitBarerootNotice);
  } else {
    beInitBarerootNotice();
  }
  document.addEventListener('shopify:section:load', beInitBarerootNotice);
})();
